import enAdmin from './en';
import ruAdmin from './ru';

export default {
  en: {
    ...enAdmin,
  },
  ru: {
    ...ruAdmin,
  },
};
